import { render, staticRenderFns } from "./CampañasWhatsapp.vue?vue&type=template&id=c06a5f6a&scoped=true"
import script from "./CampañasWhatsapp.vue?vue&type=script&lang=js"
export * from "./CampañasWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./CampañasWhatsapp.vue?vue&type=style&index=0&id=c06a5f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06a5f6a",
  null
  
)

export default component.exports